import * as braze from "@braze/web-sdk";
import { deferUntilPermitted, BRAZE_DIDOMI_VENDOR_ID, DIDOMI_ANALYTICS_PURPOSE_ID } from "../Didomi";
import { getTotalArticles } from "@theconversation/shared-components/article-read-tracking";
/**
 * Boot the Braze Web SDK.
 *
 * In order to avoid blowing through our limited MAU quota, this should only be called
 * when one or more of the following conditions is true:
 * - User has just read their second article
 * - User has just subscribed to a newsletter
 * - User has just made a donation (or started the process to make a donation)
 * - User has previously been activated for Braze
 *
 * And additionally, in all cases, the user must have either given GDPR tracking consent,
 * or else be in a region where consent is not required.
 *
 * Remember to confirm you have Didomi consent for these:
 * - BRAZE_DIDOMI_VENDOR_ID
 * - DIDOMI_ANALYTICS_PURPOSE_ID
 */
export function brazeInitialise(sdk_endpoint, api_key, userIdentifier = null) {
    // If Braze is already in session, there's no need to re-initialise it.
    if (braze.isInitialized()) {
        return;
    }
    deferUntilPermitted(BRAZE_DIDOMI_VENDOR_ID, DIDOMI_ANALYTICS_PURPOSE_ID, () => {
        braze.initialize(api_key, {
            baseUrl: sdk_endpoint,
            enableLogging: !isOnProd,
            allowUserSuppliedJavascript: false, // set to `true` to support custom HTML messages
        });
        if (userIdentifier) {
            braze.changeUser(userIdentifier);
        }
        braze.openSession();
    });
}
// Thought it was nice to enable Braze's logging in dev/staging, at least initially,
// and so built this quick helper to assist with that since we don't have
// access to the regular Nextjs or Rails config in shared components.
function isOnProd() {
    return window.location.host.includes("theconversation.com");
}
/**
 * This function checks if the business rules have been met such that we should track
 * this user with Braze's analytics. The conditions are meant to be as follows, but
 * these are not currently handled fully or correctly:
 * - User has read at least 2 articles in the last 30 days (currently just implemented as 2 articles for all time)
 * - User is a newsletter subscriber (not yet implemented)
 * - User is a financial donor (how recently?) (not yet implemented)
 *
 */
export function conditionsMetToTrackUser() {
    if (getTotalArticles() >= 2) {
        return true;
    }
    return false;
}
